import { styled } from '@linaria/react';
import { fonts, layout, semantic, space, textStyle } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  width: 100%;

  @media (min-width: ${layout.desktopBreakpoint}) {
    overflow: visible;
  }
`;

export const ScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-bottom: calc(${layout.mobileNavHeight} + ${space['space-2000']});

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding-bottom: ${space['space-800']};
  }

  & :is(a[href], button, input, select, textarea, [tabindex]) {
    scroll-margin-bottom: calc(${layout.mobileNavHeight} + ${space['space-2000']});

    @media (min-width: ${layout.desktopBreakpoint}) {
      scroll-margin-bottom: calc(${space['space-2400']} + ${space['space-400']});
    }
  }
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: ${space['space-200']};
`;

export const Heading = styled.h1`
  font-family: ${textStyle.display['size-md'].fontFamily};
  font-size: ${textStyle.display['size-md'].fontSize};
  font-weight: ${textStyle.display['size-md'].fontWeight};
  color: ${semantic.text.primary};
  text-align: center;
  line-height: ${textStyle.display['size-md'].lineHeight};
  letter-spacing: ${textStyle.display['size-md'].letterSpacing};
  margin: ${space['space-700']} 0 0;

  @media (min-width: ${layout.desktopBreakpoint}) {
    margin-top: ${space['space-1600']};
    padding: 0 min(${space['space-1400']}, 8.5%);
  }
`;

export const HeadingAccent = styled.span`
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.tertiary};
`;
